import { lodash as _ } from '../helpers';

import AnimationController from './animation';
import DataController from './data';
import ResizeController from './resize';

import { moduleQueries } from '../../../modules';

import tmplXXX from '../../../../dist/bits/http-codes/xxx/template.html';

let wrapper = null;

class PageController {

	constructor() {
		this.el = {
			pages: {},
			activePage: null
		};

		this.data = {
			pages: {},
			activePage: null
		};

		this.subscribers = []; // objects following update / render calls

		this.previous = null;
		this.active = null;
		this.loading = null;
	}

	get wrapper() {
		return wrapper;
	}

	set wrapper(el) {
		wrapper = el;
		return true;
	}

	loadModuleTemplates(data) {
		const requests = [];
		for (const d of data) {
			if (d.__typename && moduleQueries[d.__typename]) {
				requests.push(DataController.loadTemplate(moduleQueries[d.__typename].template));
			}
		}
		return Promise.all(requests);
	}

	renderPage(id, html, data, firstPageLoad) {

		if (this.previous) {
			document.body.classList.remove(`template--${this.previous.id.split('/')[1]}`);
		}

		document.body.classList.add(`template--${id.split('/')[1]}`);

		this.el.activePage = document.createElement('div');
		this.el.activePage.setAttribute('data-page', id);
		this.el.activePage.classList.add('page', `page-${id.split('/')[1]}`);
		this.el.activePage.innerHTML = '';

		for (let i = 0, l = html.length; i < l; ++i) {
			if (data && data[1] && data[1].node && data[1].node.modules[i]) {
				const pageData = Object.assign({
					previous: this.previous,
					firstPageLoad
				}, data[1]);

				this.data.activePage = pageData;

				try {
					this.el.activePage.innerHTML += _.template(html[i])({
						...pageData.node.modules[i],
						page: pageData,
						globals: data[0].globals,
						sitemap: data[0].sitemap
					});
				} catch (e) {
					console.warn('Unable to parse template!', data[1].node.modules[i].__typename, e); // eslint-disable-line no-console
				}
			} else {
				this.el.activePage.innerHTML += html[i];
			}
		}

		// gather any detached elements (such as bottom hero)
		const $detachedModules = this.wrapper.querySelectorAll('.is-detached-module');

		// attach page to wrapper
		this.wrapper.appendChild(this.el.activePage);

		// set statuses
		this.data.pages[id] = this.data.activePage;
		this.el.pages[id] = this.el.activePage;

		// send status update to subscribers
		this.update(this.status);
		this.render(this.status);

		// remove detached elements

		let frameDelay = 6;
		const removeModuleAnimation = AnimationController.set({
			update: () => {
				frameDelay--;
				if (frameDelay === 0) {
					return true;
				}
				return false;
			},
			render: () => {
				for (let i = 0; i < $detachedModules.length; i++) {
					const $module = $detachedModules[i];
					$module.remove();
				}
				ResizeController.measure();
				AnimationController.clear(removeModuleAnimation);
			}
		});

		// return state
		return this.el.activePage;
	}

	showActivePage() {
		if (!this.el.activePage.classList.contains('is-in')) {
			const { firstPageLoad } = this.data.activePage;
			AnimationController.one({
				update: () => true,
				render: () => {
					if (firstPageLoad) {
						this.el.activePage.classList.add('is-in', 'is-first-in');
					} else {
						this.el.activePage.classList.add('is-in');
					}
				}
			});
		}
	}

	activate(type, slug) {
		const id = `${type}/${slug}`;

		if ((!this.active || id !== this.active.id)) {
			this.previous = this.active;
			this.active = { id, slug, type };
			this.loading = null;

			// trigger page changes to subscribers

			this.render(this.status);

			return true;
		}
	}

	getStaticModules(type) {
		const staticModules = [];

		if (type === 'interviews') {
			staticModules.push({
				__typename: 'ModulesHeroBottom'
			});
		}

		if (type === 'experiences') {
			// staticModules.push({
			// 	__typename: 'ModulesGuestList'
			// });

			staticModules.push({
				__typename: 'ModulesHeroBottom'
			});
		}

		return staticModules;
	}

	load(type, slug) {
		return new Promise((resolve, reject) => {
			const id = `${type}/${slug}`;

			if (!this.loading) {
				this.loading = { id, slug, type };

				Promise.all([
					DataController.loadGlobals(),
					DataController.loadPage(type, slug)
				]).then((data) => {
					if (!this.loading) {
						reject(new Error('410')); // 410: gone
					} else {
						if (data[1] && data[1].node) {
							if (data[1].node.modules.length) {
								// add static modules to page skeleton
								const staticModules = this.getStaticModules(type);
								for (const module of staticModules) {
									data[1].node.modules.push(module);
								}
								// load all page modules from CMS
								this.loadModuleTemplates(data[1].node.modules).then((html) => {
									resolve({ data, html });
								}).catch(() => {
									reject(new Error('404')); // 404: not found
								});
							}
						} else {
							reject(new Error('404')); // 404: not found
						}
					}
				}).catch(() => {
					reject(new Error('500')); // 500: server error
				});
			}
		});
	}

	open(type, slug) {
		return new Promise((resolve, reject) => {
			const id = `${type}/${slug}`;
			const firstPageLoad = !this.active;

			if (!this.loading && (!this.active || id !== this.active.id)) {
				this.load(type, slug).then((e) => {
					if (this.activate(type, slug)) {
						this.renderPage(id, e.html, e.data, firstPageLoad);
						resolve();
					} else {
						const code = 410; // 410: gone
						console.warn(id, code); // eslint-disable-line no-console
						this.renderPage(id, [_.template(tmplXXX)({ code })]);
						reject(new Error(code));
					}
				}).catch((e) => {
					console.warn(id, e.message); // eslint-disable-line no-console
					if (this.activate(type, slug)) {
						this.renderPage(id, [_.template(tmplXXX)({ code: e.message })]);
						reject(new Error(e.message));
					}
				});
			}
		});
	}

	cancel() {
		if (this.loading) {
			this.loading = null;
		}
	}

	close(id = this.active.id) {
		// console.log('close', id, this.active);
		if (this.el.pages[id]) {
			this.el.pages[id].classList.remove('is-in', 'is-first-in');
			this.el.pages[id].remove();
			delete this.el.pages[id];
		}
	}

	// update / render subscription

	set(obj) {
		obj.updated = false;
		this.subscribers.push(obj);
		return this.subscribers.length - 1;
	}

	clear(index) {
		this.subscribers[index] = null;
	}

	// update / render methods

	update(data) {
		for (let i = 0, l = this.subscribers.length; i < l; ++i) {
			const subscriber = this.subscribers[i];
			if (subscriber && subscriber.update(data)) subscriber.updated = true;
		}
	}

	render(data) {
		for (let i = 0, l = this.subscribers.length; i < l; ++i) {
			const subscriber = this.subscribers[i];
			if (subscriber && subscriber.updated) {
				subscriber.updated = false;
				subscriber.render(data);
			}
		}
	}

	// validate page vs params

	isActivePage(type, slug) {
		return (`${type}/${slug}` === this.active.id);
	}

	get activePageEl() {
		return this.el.activePage;
	}

	get status() {
		return {
			active: this.active,
			loading: this.loading,
			previous: this.previous
		};
	}

}

export default new PageController();
